"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toyota = exports.Lexus = void 0;
var _styledComponents = require("styled-components");
var _index = _interopRequireDefault(require("../../LexusButton/index.styled"));
var _LexusTypography = require("../../LexusTypography");
var StyledLink = _interopRequireWildcard(require("../../Link/index.styled"));
var _ToyotaTypography = require("../../ToyotaTypography");
var _breakpoints = _interopRequireDefault(require("../../breakpoints"));
var Styled = _interopRequireWildcard(require("./index.styled"));
const Lexus = exports.Lexus = (0, _styledComponents.css)`
  ${Styled.DealerTile} {
    text-align: center;
    min-height: fit-content;
    background: #EAEAEA;
    color: #000;
  }

  ${Styled.Icon} {
    margin: auto;
    margin-bottom: 28px;
    max-width: 22.857px;
    svg {
      fill: #000;
    }
    ${(0, _breakpoints.default)("tablet", "up")} {
      margin-top: 18px;
    }
  }

  ${Styled.Heading} {
    margin-bottom: 5px;
    ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "display30",
  spacing: "1.2px"
})}
  }

  ${Styled.SubHeading} {
    margin: 0 10px;
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "subheading14",
  spacing: "0.56px"
})}
  }

  ${Styled.DealerInfoContainer} {
    margin-bottom: 28px;
  }

  ${Styled.DealerName} {
    ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "subheading16",
  spacing: "0.56px"
})}
  }

  ${Styled.DealerDistance} {
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "subheading16",
  spacing: "narrow"
})}
  }
  
  ${Styled.PhoneNumber} {
    ${(0, _LexusTypography.nobel)({
  weight: "bold",
  sizing: "subheading16",
  spacing: "1.6px"
})}
    margin-bottom: 28px;
    ${StyledLink.Anchor} {
      text-underline-offset: 5px;
    }
  }

  ${Styled.DealerFlexContainer} {
    flex-direction: column;
    gap: 3px;
  }

  ${Styled.AddressContainer} {

  }

  ${Styled.InfoLine} {
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "body14",
  spacing: "0.56px"
})}
    margin-bottom: 2px;
  }

  ${Styled.TileSection} {
    ${_index.default.A}, ${_index.default.Button} {
      padding: 0 10px;
      min-width: initial;
      width: initial;
      padding: 20px 27px;
    }
  }

  ${Styled.DealerTile} {
    gap: 28px;
    padding: 20px 20px 25px 20px;
  }

  ${Styled.DealerName} {
    text-transform: uppercase;
    margin-bottom: 5px;
  }
`;
const Toyota = exports.Toyota = (0, _styledComponents.css)`
  ${Styled.Icon} {
    max-width: 80px;
  }

  ${Styled.Heading} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "heading02_mobile",
  spacing: "-0.16px"
})}
  }

  ${Styled.SubHeading} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "button01",
  spacing: "-0.16px"
})}
  }

  ${Styled.DealerName} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "bold",
  sizing: "body02",
  spacing: "-0.16px"
})}
  }

  ${Styled.DealerDistance} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "book",
  sizing: "legal01",
  spacing: "-0.16px"
})}
    color: #d8d8d8;
    margin-left: 4px;
  }

  ${Styled.PhoneNumber} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "heading04",
  spacing: "-0.5px"
})}
    margin-bottom: 27px;
    ${StyledLink.Anchor} {
      text-underline-offset: 3px;
    }
  }

  ${Styled.InfoLine} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "regular",
  sizing: "body02",
  spacing: "-0.5px"
})}
  }

  ${Styled.TileSection} {
    ${_index.default.A}, ${_index.default.Button} {
      width: 100%;
      padding: 20px 27px;
      height: initial;
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "button01",
  spacing: "0.5px"
})}
    }
  }
`;